export const validation = {
  documentTypeRequired: "Please enter a reason",
  subjectValid: "Please enter the subject",
  messageValid: "Please enter the message",
};
